<template>
    <div class="card">
      <div class="d-flex flex-wrap justify-content-between align-item-center mt-2 mx-2">
        <h3>Field Customization</h3>
      </div>
      <div class="mt-2"></div>
        <div class="px-2">
            <div class="row">
              <div class="col-12 col-sm-6 col-md-4 col-lg-3">
                <label for="colFormLabel" class="col-form-label">Customization Type: </label>
                <v-select
                    placeholder="Select Customization Type"
                    :options="formattedFieldCustomization"
                    v-model="customizationType"
                    :reduce="name => name.id"
                    label="name"
                />
              </div>

              <div class="col-12 col-sm-6 col-md-4 col-lg-3">
                <label for="colFormLabel" class="col-form-label">Type: </label>
                <v-select
                    placeholder="Select Type"
                    :options="typeList"
                    v-model="type"
                    label="name"
                    :reduce="name => name.value"
                />
              </div>
              </div>
        </div>

        <div class="col-12 px-2 mt-2 mb-4">
          <div class="card p-2">
              <div class="container border-bottom pb-2 mb-2">
                <div class="row align-items-start">
                  <div class="col-md-4 col-12">
                    <div v-if="fieldList.heading && fieldList.heading.left">
                      <p class="mb-1" v-for="(item, i) in fieldList.heading.left" :key="i">
                        <input
                            type="checkbox"
                            class="form-check-input mx-1"
                            :id="`heading-left-${item.field}`"
                            v-model="item.is_active"
                            @change="toggleActiveStatus(item)"
                        />
                        <label :for="`heading-left-${item.field}`">{{ formatLabel(item.field) }}</label>
                      </p>
                    </div>
                  </div>

                  <div class="col-md-8 col-12 justify-content-end d-flex">
                    <div v-if="fieldList.heading && fieldList.heading.right">
                      <p class="mb-1" v-for="(item, i) in fieldList.heading.right" :key="i">
                        <input
                            type="checkbox"
                            class="form-check-input mx-1"
                            :id="`heading-right-${item.field}`"
                            v-model="item.is_active"
                            @change="toggleActiveStatus(item)"
                        />
                        <label :for="`heading-right-${item.field}`">{{ formatLabel(item.field) }}</label>
                      </p>
                    </div>
                  </div>
                </div>
              </div>

             <div class="container border-bottom pb-3 mb-4">
              <div class="row d-flex justify-content-center" v-if="fieldList.body && fieldList.body.top">
                <div
                    v-for="(item, i) in fieldList.body.top"
                    :key="i"
                    class="col-auto"
                >
                  <div>
                    <input
                        type="checkbox"
                        class="form-check-input me-1"
                        :id="`body-top-${item.field}`"
                        v-model="item.is_active"
                        @change="toggleActiveStatus(item)"
                    />
                    <label class="form-check-label" :for="`body-top-${item.field}`">
                      {{ formatLabel(item.field) }}
                    </label>
                  </div>
                </div>
              </div>

               <div class="row d-flex justify-content-between pt-2">
                 <div class="col-md-4">
                   <div v-if="fieldList.body && fieldList.body.top_left">
                     <p class="mb-1" v-for="(item, i) in fieldList.body.top_left" :key="i">
                       <input
                           type="checkbox"
                           class="form-check-input mx-1"
                           :id="`body-top-left-${item.field}`"
                           v-model="item.is_active"
                           @change="toggleActiveStatus(item)"
                       />
                       <label :for="`body-top-left-${item.field}`">{{ formatLabel(item.field) }}</label>
                     </p>
                   </div>
                 </div>

                 <div class="col-md-3 col-12">
                   <div class="table-responsive" v-if="fieldList.body && fieldList.body.top_right">
                     <p class="mb-1" v-for="(item, i) in fieldList.body.top_right" :key="i">
                       <input
                           type="checkbox"
                           class="form-check-input mx-1"
                           :id="`body-top-right-${item.field}`"
                           v-model="item.is_active"
                           @change="toggleActiveStatus(item)"
                       />
                       <label :for="`body-top-right-${item.field}`">{{ formatLabel(item.field) }}</label>
                     </p>
                   </div>
                 </div>
               </div>

              <div class="table-responsive mt-2" v-if="fieldList.body && fieldList.body.table">
                <table class="table">
                    <thead>
                       <tr>
                         <th v-for="(item, i) in fieldList.body.table"
                             :key="i">
                           <input
                               type="checkbox"
                               class="form-check-input me-1"
                               :id="`body-table-${item.field}`"
                               v-model="item.is_active"
                               @change="toggleActiveStatus(item)"
                           />
                           <label class="form-check-label mb-0" :for="`body-table-${item.field}`">
                             {{ formatLabel(item.field) }}
                           </label>
                         </th>
                       </tr>
                    </thead>
                </table>
              </div>

              <div class="row d-flex justify-content-between pt-2">
                <div class="col-md-4">
                  <div v-if="fieldList.body && fieldList.body.bottom">
                  <p class="mb-1" v-for="(item, i) in fieldList.body.bottom" :key="i">
                    <input
                        type="checkbox"
                        class="form-check-input mx-1"
                        :id="`body-bottom-${item.field}`"
                        v-model="item.is_active"
                        @change="toggleActiveStatus(item)"
                    />
                    <label :for="`body-bottom-${item.field}`">{{ formatLabel(item.field) }}</label>
                  </p>
                  </div>
                </div>

                <div class="col-md-3 col-12">
                 <div class="table-responsive" v-if="fieldList.body && fieldList.body.totals_table">
                <table class="table table-bordered">
                  <tbody>
                  <tr v-for="(item, i) in fieldList.body.totals_table"
                       :key="i">
                    <td>
                      <input
                          type="checkbox"
                          class="form-check-input me-1"
                          :id="`body-totals-table-${item.field}`"
                          v-model="item.is_active"
                          @change="toggleActiveStatus(item)"
                      />
                      <label class="form-check-label mb-0" :for="`body-totals-table-${item.field}`">
                        {{ formatLabel(item.field) }}
                      </label>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              </div>
              </div>
            </div>

            <div class="container pb-2 mb-2" v-if="fieldList.signature">
              <div class="row d-flex justify-content-between border-bottom">
                <div
                    v-for="(item, i) in fieldList.signature"
                    :key="i"
                    class="col-6 col-md-3 mb-2"
                >
                  <div>
                    <input
                        type="checkbox"
                        class="form-check-input me-1"
                        :id="`footer-${item.field}`"
                        v-model="item.is_active"
                        @change="toggleActiveStatus(item)"
                    />
                    <label class="form-check-label" :for="`footer-${item.field}`">
                      {{ formatLabel(item.field) }}
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <!-- Extra Settings section -->
            <div class="container pb-2 mb-4" v-if="fieldList.extra_settings">
              <div class="row border-top pt-3">
                <div
                  v-for="(item, i) in fieldList.extra_settings"
                  :key="i"
                  class="col-12 mb-3"
                >
                  <div class="d-flex align-items-center mb-2">
                    <input
                      type="checkbox"
                      class="form-check-input me-1"
                      :id="`extra-${item.field}`"
                      v-model="item.is_active"
                    />
                    <label class="form-check-label fw-bold" :for="`extra-${item.field}`">
                      {{ formatLabel(item.field) }}
                    </label>
                  </div>
                
                  <!-- Show inputs if margin and checkbox is active -->
                  <div v-if="item.field === 'margin' && item.is_active" class="row mt-2">
                    <div class="col-md-3 mb-2">
                      <label>Top Margin (mm)</label>
                      <input
                        type="number"
                        class="form-control"
                        v-model="marginValues.top"
                        placeholder="0"
                      />
                    </div>
                    <div class="col-md-3 mb-2">
                      <label>Right Margin (mm)</label>
                      <input
                        type="number"
                        class="form-control"
                        v-model="marginValues.right"
                        placeholder="0"
                      />
                    </div>
                    <div class="col-md-3 mb-2">
                      <label>Bottom Margin (mm)</label>
                      <input
                        type="number"
                        class="form-control"
                        v-model="marginValues.bottom"
                        placeholder="0"
                      />
                    </div>
                    <div class="col-md-3 mb-2">
                      <label>Left Margin (mm)</label>
                      <input
                        type="number"
                        class="form-control"
                        v-model="marginValues.left"
                        placeholder="0"
                      />
                    </div>
                  </div>
                  <div v-if="item.field === 'footer_note' && item.is_active" class="row mt-2">
                    <div class="col-md-3 mb-2">
                      <label>Note</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="footerNote"
                      />
                    </div>
                  </div>
                  <div v-if="item.field === 'cover_photo_upload' && item.is_active" class="row mt-2">
                    <div class="col-md-8 mb-2">
                      <CoverPhotoUploader
                        :coverPhoto="coverPhoto"
                        :isEditable="true"
                        @uploaded="uploadCover"
                      />
                    </div>
                  </div>
                  <div v-if="item.field === 'footer_photo_upload' && item.is_active" class="row mt-2">
                    <div class="col-md-8 mb-2">
                      <CoverPhotoUploader
                        :coverPhoto="footerPhoto"
                        :isEditable="true"
                        @uploaded="uploadFooter"
                      />
                    </div>
                  </div>
                  <div class="col-12 mt-2 text-end">
                    <button class="btn btn-primary" @click="saveExtraSetting(item)">Save</button>
                  </div>
                </div>
              </div>
            </div>

             <div class="container pb-2 mb-2" v-if="fieldList.footer">
               <div class="row d-flex justify-content-between">
                 <div
                     v-for="(item, i) in fieldList.footer"
                     :key="i"
                     class="col-6 col-md-3 mb-2"
                 >
                   <div>
                     <input
                         type="checkbox"
                         class="form-check-input me-1"
                         :id="`footer-${item.field}`"
                         v-model="item.is_active"
                         @change="toggleActiveStatus(item)"
                     />
                     <label class="form-check-label" :for="`footer-${item.field}`">
                       {{ formatLabel(item.field) }}
                     </label>
                   </div>
                 </div>
               </div>
            </div>

          </div>
        </div>

        <Loader v-if="loading"/>
    </div>
</template>

<script setup>
import {inject, onMounted, ref, watch} from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import Loader from '@/components/atom/LoaderComponent'
import handleCompany from "@/services/modules/company";
import handleChartAccount from '@/services/modules/chartAccount'
import CoverPhotoUploader from '@/components/atom/PhotoUploader';

import { computed } from 'vue';

const store = useStore();
const route = useRoute();
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const loading = ref(false)
const customizationType = ref(null)
const typeList = ref([])
const fieldList = ref([])
const type = ref(null)
const fieldCustomizationType = ref({});
const footerNote = ref(null);
const coverPhoto = ref(null);
const footerPhoto = ref(null);
const marginValues = ref({
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
});

const token = computed(() => localStorage.getItem('token'));
const formattedFieldCustomization = computed(() => {
  return Object.keys(fieldCustomizationType.value).map(key => ({ id: key, name: fieldCustomizationType.value[key] }));
})

const { fetchFieldTypesList, fetchCustomizationFields, storeFieldCustomization } = handleCompany();
const {fetchHome} = handleChartAccount()

const formatLabel = (value) => {
  if (!value) return '';
  return value.replace(/_/g, ' ')
      .replace(/\b\w/g, char => char.toUpperCase());
}

function getQuery() {
  return `?company_id=${route.params.companyId}`;
}

const getFieldTypesList = async () => {
  let query = `?company_id=${route.params.companyId}`;
  query += '&customization_type='+ customizationType.value
  typeList.value = []
  type.value = null
  loading.value = true

    await fetchFieldTypesList(query).then(res => {
        if (!res.status){
            return
        }
        typeList.value = res.data
    }).catch(err => {
        console.log(err)
    }).finally(() => {
        loading.value = false
    })
}

const toggleActiveStatus = (item) => {
  const payload = {
    is_active: item.is_active,
    company_id: route.params.companyId,
    customization_type: item.customization_type,
    type: item.type,
    section: item.section,
    sub_section: item.sub_section,
    field: item.field,
  };

  storeFieldCustomization(payload, getQuery()).then((res) => {
    loading.value = false
    if (!res.status) return showError(res.message)
    showSuccess(res.message)
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

const uploadCover = (file) => {
  coverPhoto.value = file;
};

const uploadFooter = (file) => {
  footerPhoto.value = file;
};

const uploadCoverFooter = async (item) => {
  if (item.field === 'cover_photo_upload' && ! coverPhoto.value) {
    return showError('Please upload a cover photo first.');
  }

  if (item.field === 'footer_photo_upload' && ! footerPhoto.value) {
    return showError('Please upload a footer photo first.');
  }

  const payload = new FormData();

  if(item.field === 'cover_photo_upload') {
    payload.append('value', item.is_active ? coverPhoto.value : null);
  }
  
  if(item.field === 'footer_photo_upload') {
    payload.append('value', item.is_active ? footerPhoto.value : null);
  }

  // Append common fields
  payload.append('is_active', item.is_active ? 1 : 0);
  payload.append('company_id', route.params.companyId);
  payload.append('customization_type', customizationType.value);
  payload.append('type', type.value);
  payload.append('section', 'extra_settings');
  payload.append('sub_section', '');
  payload.append('field', item.field);

  loading.value = true;
  try {
    const res = await storeFieldCustomization(payload, getQuery());
    if (!res.status) return showError(res.message);
    showSuccess(`${formatLabel(item.field)} saved successfully.`);
  } catch (err) {
    showError('Something went wrong while saving extra setting.');
  } finally {
    loading.value = false;
  }
};

const saveExtraSetting = async (item) => {
  let value = null;

  if (item.field === 'cover_photo_upload') {
    uploadCoverFooter(item);
    return;
  }

  if (item.field === 'footer_photo_upload') {
    uploadCoverFooter(item);
    return;
  }

  if(item.field === 'margin') {
    value = marginValues.value;
  }

  if(item.field === 'footer_note') {
    value = footerNote.value;
  }

  const payload = {
    is_active: item.is_active,
    company_id: route.params.companyId,
    customization_type: customizationType.value,
    type: type.value,
    section: 'extra_settings',
    sub_section: '',
    field: item.field,
    value: value,
  };

  loading.value = true;
  try {
    const res = await storeFieldCustomization(payload, getQuery());
    if (! res.status) return showError(res.message);
    showSuccess(`${formatLabel(item.field)} saved successfully.`);
  } catch (err) {
    showError("Something went wrong while saving extra setting.");
  } finally {
    loading.value = false;
  }
};

const getCustomizationFields = async () => {
  let query = `?company_id=${route.params.companyId}`;
  query += '&type='+ type.value
  query += '&customization_type='+ customizationType.value
  loading.value = true
  fieldList.value = [];

  await fetchCustomizationFields(query).then(res => {
    if (!res.status){
      showError(res.message)
      return
    }
    fieldList.value = res.data
    if (fieldList.value.extra_settings) {
      // Margin
      const marginField = fieldList.value.extra_settings && fieldList.value.extra_settings.find(f => f.field === 'margin');
      marginValues.value = (marginField && marginField.value) || { top: 0, right: 0, bottom: 0, left: 0 };

      // Cover Photo Upload
      const coverPhotoUpload = fieldList.value.extra_settings && fieldList.value.extra_settings.find(f => f.field === 'cover_photo_upload');
      coverPhoto.value = (coverPhotoUpload && coverPhotoUpload.value);

      const footerPhotoUpload = fieldList.value.extra_settings && fieldList.value.extra_settings.find(f => f.field === 'footer_photo_upload');
      footerPhoto.value = (footerPhotoUpload && footerPhotoUpload.value);
    }
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

watch(customizationType, (newVal) => {
   getFieldTypesList()
})

watch(type, (newVal) => {
  getCustomizationFields()
})

onMounted(() => {
  Promise.all([
    fetchHome().then(res => {
      if (!res.data) {
        return;
      }
      if (res.data.field_customization_type) {
         fieldCustomizationType.value = res.data.field_customization_type;
      }
    })
  ])

})
</script>
